import React from 'react';
import { InfoImage } from 'src/assets/images';
import Tooltip from '../tooltip/tooltip';

type Orientation = 'top' | 'bottom' | 'left' | 'right';

type Props = {
  className?: string;
  onOpenEvent: () => void;
  text: string;
  orientation?: Orientation;
  lightMode: boolean;
};

export default function Info(props: Props) {
  const getTooltip = (isMobile: boolean) => (
    <Tooltip
      onOpenEvent={props.onOpenEvent}
      content={props.text}
      orientation={props.orientation || 'top'}
      isMobile={isMobile}
      lightMode={props.lightMode}
      showOnHover
    >
      <div className="cursor-pointer shrink-0 w-4.5 h-4.5 md:w-6.5 md:h-6.5">
        <img src={InfoImage} alt="info" />
      </div>
    </Tooltip>
  );

  return (
    <div className={props.className ? props.className : ''}>
      <span className="align-middle md:hidden">{getTooltip(true)}</span>
      <span className="hidden md:flex md:items-center">{getTooltip(false)}</span>
    </div>
  );
}
